<template>
  <validation-observer ref="simpleRules">
    <!-- Nama -->
    <b-form-group
      label="Nama"
      label-for="v-name"
    >
      <validation-provider
        #default="{ errors }"
        name="Nama"
        rules="required"
      >
        <b-form-input
          id="v-name"
          v-model="form.name"
          :state="errors.length > 0 ? false : null"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
  </validation-observer>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
} from 'bootstrap-vue'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
// Vee Validate
import { required } from '@validations'

export default {
  name: 'RolesInfoForm',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      required,
    }
  },
  methods: {
    async validationForm() {
      const response = await this.$refs.simpleRules.validate()
      return response
    },
  },
}
</script>
